<template>
  <dl class="obituary-detailed-list">
    <template v-for="item in publication">
      <dt v-if="item.text" :key="`dt-${item.text}`" v-text="item.label" />
      <dd v-if="item.text" :key="`dd-${item.text}`" v-text="item.text" />
    </template>

    <dt v-if="!noDonations && memorialFund" v-text="texts.common.fundraising" />
    <dd v-if="!noDonations && memorialFund">
      <button
        class="btn link"
        @click.prevent="toggleModal('donationInitial')"
        v-text="memorialFund"
      />
    </dd>

    <dt v-text="texts.obituaryImageInfo.print" />
    <dd>
      <a :href="downloadLink" v-text="texts.obituaryImageInfo.download" />
    </dd>
  </dl>
</template>

<script>
import { format, isValid, parseISO } from 'date-fns';
import svLocale from 'date-fns/locale/sv';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ObituaryImageInfo',

  data() {
    const { noDonations, memorialFund, downloadLink } = this.$mountEl.dataset;

    return {
      noDonations: noDonations === 'true',
      memorialFund,
      downloadLink,
      texts: lavendlaObituary,
    };
  },

  computed: {
    ...mapState('orders', ['order', 'isLoading']),

    publicationDate() {
      const date = this.order?.memorialPage?.obituary_image_publication_date;
      const parsedDate = date ? parseISO(date) : '';
      return isValid(parsedDate)
        ? format(parsedDate, 'yyyy-MM-dd', { locale: svLocale })
        : '';
    },

    publication() {
      const { publishedIn, publishedDate } = this.texts.obituaryImageInfo;

      return [
        {
          label: publishedIn,
          text: this.order?.memorialPage?.obituary_image_publication,
        },
        { label: publishedDate, text: this.publicationDate },
      ];
    },
  },

  methods: {
    ...mapActions('createComment', ['toggleModal']),
  },
};
</script>
